import React from 'react';
import { SectionLayout } from '../../components/Layouts';
import ActionCard from '../../components/CallToActionCard';
import { Row } from '../../components/Grid';
import * as T from '../../components/Typography';
import composeStyle from '../../utils/composeStyle';

import * as S from './style';

import { navRoutes } from '../../constants';
import Banners from './Banners';

const Title = composeStyle(T.H2, 'H3', 'H4');

const dataEnglish = [
  {
    id: 1,
    color: 'blue',
    to: navRoutes.memberHome,
    title: 'individuals and\ncommunity\nmembers',
    subtitle: 'Enjoy fun activities, without spending money! ',
  },
  {
    id: 2,
    color: 'pink',
    to: navRoutes.earnGroupsHome,
    title: 'charities and\ncommunity\ngroups',
    subtitle: 'Attract, retain and thank volunteers',
  },
  {
    id: 3,
    color: 'midnight',
    to: navRoutes.spendPartnerHome,
    title: 'businesses and\nactivity\nproviders',
    subtitle: 'Attract new visitors and support your community',
  },
  {
    id: 4,
    color: 'purple',
    to: navRoutes.commissioners,
    title: 'commissioners\nand\nfunders',
    subtitle: 'Improve outcomes for public services and communities',
  },
];

const dataWelsh = [
  {
    id: 1,
    color: 'blue',
    to: navRoutes.memberHome,
    title: 'Unigolion',
    subtitle: 'Mwynhau gweithgareddau hwylus, heb wario arian!',
  },
  {
    id: 2,
    color: 'pink',
    to: navRoutes.earnGroupsHome,
    title: 'Elusennau a\ngrwpiau\ncymunedol',
    subtitle: 'Denu, cadw a rhoi diolch i wirfoddolwyr',
  },
  {
    id: 3,
    color: 'midnight',
    to: navRoutes.spendPartnerHome,
    title: 'Busnesau a\ndarparwyr\ngweithgareddu',
    subtitle: 'Denu ymwelwyr newydd a cefnogi eich cymuned',
  },
  {
    id: 4,
    color: 'purple',
    to: navRoutes.commissioners,
    title: 'Comisiynwyr\na\ncyllidwyr',
    subtitle: 'Gwella canlyniadau ar gyfer gwasanaethau cyhoeddus a chymunedau',
  },
];

const ActionCardsSection = ({ language = 'english' }) => {
  const data = language === 'english' ? dataEnglish : dataWelsh;

  return (
    <SectionLayout bgcolor="blueGrad">
      <Title color="white" mb={5} mbT={4} mbM={2}>
        {language === 'english' ? 'Get started today' : 'Cychwynwch Heddiw'}
      </Title>
      <Row jc="center">
        {data.map(e => (
          <S.Col w={[4, 3, 3]} mt={2} key={e.id}>
            <ActionCard
              color={e.color}
              to={e.to}
              title={e.title}
              subtitle={e.subtitle}
              language={language}
            />
          </S.Col>
        ))}
      </Row>
    </SectionLayout>
  );
};

export { Banners };
export default ActionCardsSection;
